//
// Shop: Global events on change currency
//

( function($, waTheme) {

    if (window.waTheme.currency_data) {
        waTheme.addCurrency(window.waTheme.currency_data);
    }

    $(".js-currency-button").on("click", function() {
        var url = new URL(location.href);
        url.searchParams.append("currency", $(this).data("currency"));
        location.href = url.href;
    });

    $(".js-currency-select").change(function () {
        var href = location.href,
            url = (href.indexOf('?') == -1) ? href += '?' : href += '&';
        location.href = url + 'currency=' + $(this).val();
    });

})(jQuery, window.waTheme);
